import React from 'react';
import PropTypes from 'prop-types';

import RedirectWithStatus from '../../../shared/components/redirect-with-status';
import { withError } from '../../../shared/components/error-boundary';
import { Helpers } from '../../../core/src/helpers';

class PrivateStoreRedirect extends React.PureComponent {
    static propTypes = {
        privateStoreOnly: PropTypes.bool,
        privateStores: PropTypes.array,
    };

    static defaultProps = {
        privateStores: [],
        privateStoreOnly: false,
    };

    render() {
        const { personData, privateStoreOnly, privateStores, to } = this.props;
        const { pStoreID } = personData;
        const normalizedID = pStoreID && pStoreID.replace(/[\s|\_|\-]+/ig,"");

        let redirectUrl = to || '/'
        //if pStoreID in url doesn't match what comes back from hpServices then redirect to login screen
        if(!to && typeof document !== 'undefined' && document.location && document.location.search){
            let urlPStoreID = Helpers.getSearch(window.location.search).pStoreID;
           redirectUrl = urlPStoreID && urlPStoreID !== pStoreID ? `/webapp/wcs/stores/servlet/LogonForm?storeId=10151&catalogId=10051&langId=-1&pStoreAcessValid=false&pStoreID=${pStoreID}&URL=%2Fus%2Fen%3FpStoreID%3D${pStoreID}` : redirectUrl;
        }
        if (
            !privateStoreOnly ||
            !personData.hasOwnProperty('pStoreID') || //wait till user data has been retrieved HPServices
            (pStoreID && (privateStores.length === 0 || privateStores.includes(pStoreID) || privateStores.includes(normalizedID))) //failsafe for if privateStore list is unavailable
        ) {
            return null;
        }
        
        return <RedirectWithStatus to={redirectUrl} />;
    }
}

export default withError(PrivateStoreRedirect);
